import React from "react";

export default function PrivacyPage() {
  return (
    <div className="page-legal">
      <h1>Privacy Policy</h1>
      <p>
        This Privacy Policy explains how xX Developments (PTY) Ltd (“xX Developments”,
        “we”, “us”) collects and uses information in the Nia COACH Portal (“Nia COACH”).
      </p>
      <h2>1. Information We Collect</h2>
      <ul>
        <li>Account data: name, email, role, organization.</li>
        <li>Usage data: sessions, messages, and feature interactions.</li>
        <li>Feedback: ratings and optional feedback comments.</li>
      </ul>
      <h2>2. How We Use Information</h2>
      <p>
        We use data to deliver coaching features, personalize the experience, provide
        organizational insights, and improve service quality.
      </p>
      <h2>3. Legal Basis</h2>
      <p>
        We process data based on your consent, contractual necessity, and legitimate
        interests in operating and improving Nia COACH.
      </p>
      <h2>4. Data Sharing</h2>
      <p>
        We do not sell personal data. We may share data with trusted service providers
        that support infrastructure, analytics, and security, under confidentiality obligations.
      </p>
      <h2>5. Data Storage and Retention</h2>
      <p>
        Data is stored securely and retained only as long as necessary for the purposes
        described above or as required by law.
      </p>
      <h2>6. Your Rights</h2>
      <p>
        You may request access, correction, deletion, or export of your personal data,
        subject to applicable law.
      </p>
      <h2>7. Security</h2>
      <p>
        We use reasonable technical and organizational measures to protect data, but no
        system can be 100% secure.
      </p>
      <h2>8. Contact</h2>
      <p>
        For privacy questions, contact xX Developments (PTY) Ltd.
      </p>
    </div>
  );
}
